/* PSM redesign — copy the SKU on click or Enter/Space. Handles two targets:
   the .skuA part-number field (single-variant products) and the .model-readout
   pill (combined-listing / Model-option products). Reads the live value span
   (.skuA-value / .model-readout__val) so the copied value stays correct after a
   variant change. Delegated + guarded so multiple product sections bind once. */
(function () {
  "use strict";
  if (window.__psmSkuCopy) return;
  window.__psmSkuCopy = true;

  function setLabel(field, txt) {
    field.setAttribute("aria-label", txt);
  }

  function flash(field, sku) {
    field.classList.add("is-copied");
    setLabel(field, "Copied " + sku);
    window.clearTimeout(field.__psmT);
    field.__psmT = window.setTimeout(function () {
      field.classList.remove("is-copied");
      setLabel(field, "Copy SKU " + sku);
    }, 1400);
  }

  function copy(field) {
    var valEl = field.querySelector(".skuA-value, .model-readout__val");
    var sku = valEl ? (valEl.textContent || "").trim() : "";
    if (!sku) return;

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(sku).then(
        function () { flash(field, sku); },
        function () {}
      );
      return;
    }
    // Legacy fallback (non-secure contexts)
    try {
      var ta = document.createElement("textarea");
      ta.value = sku;
      ta.setAttribute("readonly", "");
      ta.style.position = "absolute";
      ta.style.left = "-9999px";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
      flash(field, sku);
    } catch (e) {
      /* clipboard unavailable — no-op */
    }
  }

  var SELECTOR = ".skuA, .model-readout[data-psm-copyable]";

  document.addEventListener("click", function (e) {
    var field = e.target.closest(SELECTOR);
    if (field) copy(field);
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " " && e.key !== "Spacebar") return;
    var field = e.target.closest(SELECTOR);
    if (!field) return;
    e.preventDefault();
    copy(field);
  });
})();
